<template>
  <a
    href="https://cut30.co"
    target="_blank"
    rel="noopener noreferrer"
    :class="[
      'cut30-alum-badge inline-flex items-center rounded-full select-none no-underline',
      size === 'sm' ? 'gap-1.5 px-2 py-1' : 'gap-2 px-3 py-1.5'
    ]"
    style="background: linear-gradient(120deg, #0d1f4e 0%, #111827 100%); text-decoration: none;"
    :title="tooltip"
    @click.stop
  >
    <!-- Blue circle checkmark -->
    <span
      :class="size === 'sm' ? 'w-4 h-4' : 'w-5 h-5'"
      class="flex-shrink-0 rounded-full flex items-center justify-center"
      style="background: linear-gradient(135deg, #3b5bdb 0%, #5c7cfa 100%)"
    >
      <svg
        :class="size === 'sm' ? 'w-2.5 h-2.5' : 'w-3 h-3'"
        viewBox="0 0 12 12"
        fill="none"
        aria-hidden="true"
      >
        <path d="M2 6l2.8 2.8 5.2-5.2" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
    <!-- Text -->
    <span
      :class="size === 'sm' ? 'text-xs' : 'text-sm'"
      class="font-bold text-white whitespace-nowrap leading-none"
      style="font-family: inherit;"
    >Cut<span class="font-serif italic font-normal mx-0.5">30</span>Alum</span>
  </a>
</template>

<script>
export default {
  name: 'Cut30AlumBadge',
  props: {
    size: {
      type: String,
      default: 'md',
      validator: v => ['sm', 'md'].includes(v)
    },
    tooltip: {
      type: String,
      default: 'This creator took Cut30, a 30-day short-form video bootcamp'
    }
  }
};
</script>
